import {connect} from "react-redux";
import ParkingAccountList from "./List";
import {bindActionCreators} from "redux";
import {getFilter} from "../../../../service/Account/action";
import {getCityByStateId} from "../../../../service/Account/action";
import {accountList} from "../../../../service/Parking/action";

const mapStateToProps = (state) => ({
    accountDetails:state.Parking.accountListDetails,
    accountFilterContent:state.Valet.accountFilterContent,
    geoCity:state.Dropdown.geoCity,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            accountList,
            getFilter,
            getCityByStateId
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ParkingAccountList);
